import { ChangeEvent, useEffect, useState } from "react";
import useFormStore from "../../store/formData";
import TextInput from "../TextInput/TextInput";

const TextInputContainerNumber = (props) => {
  const { formData, setFormData } = useFormStore();
  const [displayValue, setDisplayValue] = useState("");

  useEffect(() => {
    if (formData[props.data.id] !== undefined) {
      const rawValue = formData[props.data.id];
      setDisplayValue(formatNumberWithCommas(rawValue));
    } else {
      setFormData(props.data.id, "");
      setDisplayValue("");
    }
  }, [formData, props.data.id, setFormData]);

  // Helper function to format number with commas
  const formatNumberWithCommas = (value) => {
    if (!value) return "";
    // Remove all non-digit characters
    const numericValue = value.replace(/\D/g, "");
    // Add commas every 3 digits
    return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Helper function to remove commas for storage
  const removeCommas = (value) => {
    return value.replace(/,/g, "");
  };

  function handleChange(e) {
    const inputValue = e.target.value;
    // Remove existing commas to prevent double formatting
    const rawValue = removeCommas(inputValue);

    // Update the display value with formatting
    const formattedValue = formatNumberWithCommas(rawValue);
    setDisplayValue(formattedValue);

    // Store the raw numeric value
    setFormData(props.data.id, rawValue);
  }

  return (
    <TextInput
      size="md"
      label={props.data.name}
      value={displayValue}
      icon={props.data.icon}
      disabled={false}
      type="text" // Use text type to allow commas
      placeholder=""
      onChange={handleChange}
      id={props.data.id}
    />
  );
};
export default TextInputContainerNumber;
